import { Component, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { Input, Output, EventEmitter } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

import { Subscription } from 'rxjs';

import { ViewRenderer } from '@unpispas/upp-wdgt';

import { languageService, languageSupport } from '@unpispas/upp-base';
import { dataService  } from '@unpispas/upp-data';
import { viewService } from '@unpispas/upp-base';

import { QrCodeView } from '@unpispas/upp-data';

export type QrCodeThumbTargets = 'DISPLAY' | 'SELECT' | 'TABLENO';

@Component({
    selector: 'upp-qrcode-thumb',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './upp-thumb.html',
    styleUrls: [
      './upp-thumb.scss'
    ],
    providers: [{
        provide: ViewRenderer,
        useFactory: (change: ChangeDetectorRef) => new ViewRenderer(change),
        deps: [ChangeDetectorRef]
    }]       
})
export class UppQrCodeThumbComponent extends languageSupport implements OnChanges, OnDestroy {
    @Input() qrcode: QrCodeView | null = null;
    @Input() target: QrCodeThumbTargets = 'DISPLAY';
    @Input() checked = false;
    @Input() disabled = false;

    @Output() Checked = new EventEmitter <QrCodeView | null> ();
    @Output() Select = new EventEmitter <QrCodeView | null> ();

    private _qrcode_subscription: Subscription | null = null;

    constructor(private lang: languageService, private change: ViewRenderer, private data: dataService, public view: viewService){
        super(lang, change.cdref);
    }

    ngOnChanges(changes: SimpleChanges){
        if (this._qrcode_subscription){
            this._qrcode_subscription.unsubscribe();
            this._qrcode_subscription = null;
        }

        if (this.qrcode){
            this._qrcode_subscription = this.qrcode.OnViewRefresh.subscribe(
            () => {
                this.change.markForCheck();
            });
        }

        if ('checked' in changes) {
            this.change.markForCheck();
        }
    }

    ngOnDestroy(): void {
        super.OnDestroy();

        if (this._qrcode_subscription){
            this._qrcode_subscription.unsubscribe();
            this._qrcode_subscription = null;
        }
    }

    /********************************/
    /* EVENT HANDLERS               */
    /********************************/

    OnSelect(){
        if (this.target === 'SELECT') {
            this.OnCheck();
            return;
        }

        this.Select.emit(this.qrcode);
    }

    OnCheck(){
        if (this.disabled) {
            return;
        }
        
        this.Checked.emit(this.qrcode);
    }
}